import React from 'react'
import { BreadcrumbItem } from './BreadcrumbItem'

export const Toolbar = (props) => {
  
  return (
    <div className="toolbar" id="kt_toolbar">
    <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">
      <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
        <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{props.title}</h1>
        <span className="h-20px border-gray-300 border-start mx-4" />
        <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
        {
            props.enlaces.map((enlace,index)=>{
              return <BreadcrumbItem
              key={'li_toolbar_'+index}
              bullet={enlace.bullet}
              to={enlace.to}
              title={enlace.title}
              muted={enlace.muted}
              />
            })
          
          }
        </ul>
      </div>

      <div className="d-flex align-items-center gap-2 gap-lg-3">
      
      </div>
      
    </div>
 
  </div>
  )
}
